import { roles } from "../helper";

export const PAGE_ACCESS_CONTROLLED_ROLES = [roles.MARKETING_USER, roles.SUB_ADMIN];

/** Personal pages always available to signed-in page-access-controlled roles. */
export const PERSONAL_PAGE_KEYS = ["profile"];

export const PAGE_KEY_TO_PATH: Record<string, string> = {
  dashboard: "/dashboard",
  trends: "/trends",
  goals: "/goals",
  managetickets: "/managetickets",
  addticket: "/addticket",
  analytics: "/analytics",
  salesrep: "/salesrep",
  "event-update": "/event-update",
  teamupdate: "/teamupdate",
  venueupdate: "/venueupdate",
  ticketmaster: "/ticketmaster",
  setting: "/setting",
  appversion: "/app-version",
  appupdate: "/app-update",
  "new-list": "/new-list",
  tickets: "/tickets",
  users: "/users",
  affiliate: "/affiliate",
  settings: "/setting",
  logs: "/auditLogs",
  profile: "/profile",
};

export const PATH_TO_PAGE_KEY: Record<string, string> = {
  "/dashboard": "dashboard",
  "/trends": "trends",
  "/goals": "goals",
  "/managetickets": "managetickets",
  "/addticket": "addticket",
  "/analytics": "analytics",
  "/salesrep": "salesrep",
  "/event-update": "event-update",
  "/teamupdate": "teamupdate",
  "/venueupdate": "venueupdate",
  "/ticketmaster": "ticketmaster",
  "/setting": "setting",
  "/app-version": "appversion",
  "/app-update": "appupdate",
  "/new-list": "new-list",
  "/tickets": "tickets",
  "/users": "users",
  "/user/:userId": "users",
  "/affiliate": "affiliate",
  "/affiliate/transactions/:id": "affiliate",
  "/settings": "setting",
  "/logs": "logs",
  "/auditLogs": "logs",
  "/profile": "profile",
};

export const AFFILIATE_ADMIN_PAGE_PRIORITY = [
  "dashboard",
  "managetickets",
  "addticket",
  "users",
  "affiliate",
  "event-update",
  "teamupdate",
  "venueupdate",
  "setting",
  "appversion",
  "profile",
];

export const AFFILIATE_ADMIN_ALLOWED_PAGE_KEYS = [
  "dashboard",
  "trends",
  "goals",
  "managetickets",
  "addticket",
  "users",
  "analytics",
  "salesrep",
  "affiliate",
  "event-update",
  "teamupdate",
  "venueupdate",
  "ticketmaster",
  "setting",
  "appversion"
  
];

export const MARKETING_USER_PAGE_PRIORITY = [
  "dashboard",
  "trends",
  "goals",
  "managetickets",
  "addticket",
  "users",
  "analytics",
  "salesrep",
  "affiliate",
  "event-update",
  "teamupdate",
  "venueupdate",
  "ticketmaster",
  "setting",
  "logs",
  "profile",
];

export const MARKETING_USER_ALLOWED_PAGE_KEYS = [...MARKETING_USER_PAGE_PRIORITY];

export const SUB_ADMIN_PAGE_PRIORITY = [
  "dashboard",
  "trends",
  "goals",
  "managetickets",
  "addticket",
  "users",
  "analytics",
  "salesrep",
  "affiliate",
  "event-update",
  "teamupdate",
  "venueupdate",
  "ticketmaster",
  "setting",
  "appversion",
  "logs",
  "profile",
];

export const SUB_ADMIN_ALLOWED_PAGE_KEYS = [
  "dashboard",
  "trends",
  "goals",
  "managetickets",
  "addticket",
  "users",
  "analytics",
  "salesrep",
  "affiliate",
  "event-update",
  "teamupdate",
  "venueupdate",
  "ticketmaster",
  "setting",
  "appversion",
];

export const ROLE_ALLOWED_PAGE_KEYS: Record<string, string[]> = {
  [roles.AFFILIATER_ADMIN]: [...AFFILIATE_ADMIN_ALLOWED_PAGE_KEYS],
  [roles.MARKETING_USER]: [...MARKETING_USER_ALLOWED_PAGE_KEYS],
  [roles.SUB_ADMIN]: [...SUB_ADMIN_ALLOWED_PAGE_KEYS],
};

export const ROLE_DEFAULT_PAGE_KEYS: Record<string, string[]> = {
  [roles.AFFILIATER_ADMIN]: [...AFFILIATE_ADMIN_PAGE_PRIORITY],
  [roles.MARKETING_USER]: [...MARKETING_USER_PAGE_PRIORITY],
  [roles.SUB_ADMIN]: [...SUB_ADMIN_PAGE_PRIORITY],
};

export const isPageAccessControlledRole = (role: string) => PAGE_ACCESS_CONTROLLED_ROLES.includes(role);

export const getRolePagePriority = (role: string) => {
  if (role === roles.MARKETING_USER) {
    return MARKETING_USER_PAGE_PRIORITY;
  }
  if (role === roles.SUB_ADMIN) {
    return SUB_ADMIN_PAGE_PRIORITY;
  }
  return AFFILIATE_ADMIN_PAGE_PRIORITY;
};

export const getRoleAllowedPageKeys = (role: string) => ROLE_ALLOWED_PAGE_KEYS[role] || [];
export const getRoleDefaultPageKeys = (role: string) => ROLE_DEFAULT_PAGE_KEYS[role] || [];

export const withPersonalPageKeys = (pageKeys: string[]) =>
  [...new Set([...pageKeys, ...PERSONAL_PAGE_KEYS])];

export const resolveDefaultPathFromPageKeys = (role: string, allowedPageKeys: string[]) => {
  if (!isPageAccessControlledRole(role)) {
    return "";
  }

  const priority = getRolePagePriority(role);
  for (const pageKey of priority) {
    if (allowedPageKeys.includes(pageKey)) {
      return PAGE_KEY_TO_PATH[pageKey];
    }
  }
  return "/no-access";
};
